import { render, staticRenderFns } from "./PecaProfissionalIndependenteForm.vue?vue&type=template&id=f56fbdb6"
import script from "./PecaProfissionalIndependenteForm.vue?vue&type=script&lang=js"
export * from "./PecaProfissionalIndependenteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports